import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchAdminListData } from "./rolebaseAPI";
export interface AdminListState {
  adminListData: Array<any>;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: AdminListState = {
  adminListData: [],
  status: "idle",
};

export const GetAdminListData = createAsyncThunk("AdminList/fetchAdminListData", async (data:any) => {
  const response = await fetchAdminListData(data);
  return response;
});

export const AdminListSlice = createSlice({
  name: "AdminList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetAdminListData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetAdminListData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetAdminListData.fulfilled, (state, action) => {
        state.status = "success";
        state.adminListData = action.payload;
      });
  },
});

export const {} = AdminListSlice.actions;

export const selectAdminListData = (state: RootState) => {
  return state.AdminList.adminListData;
};

export default AdminListSlice.reducer;
